<template>
  <div>
    <div
      class="Fuell-Overlay Fuell-Overlay--lower-z-index"
      @click.self="closeModal"
    >
      <div
        class="Fuell-Modal"
        :class="fuellModalAlignmentClass"
      >
        <div
          class="Fuell-Modal--window Fuell-Modal--window--centered"
          :class="modalWindowSize"
        >
          <button
            class="Fuell-Modal--close-button"
            @click="closeModal"
          >
            <img
              :src="require('@/assets/img/icons/close.svg')"
              alt="close"
            />
          </button>
          <h3 class="Fuell-Modal--title"> {{modalHeader}}
          </h3>
          <div
            class="Fuell-Modal--content overflow-hidden"
            :class="fuellModalContentClass"
          >
            <div v-if="hasResources">
              <p class="Fuell-Text Fuell-Text--centered">{{modalResourcesLabel}}</p>
            </div>
            <div v-else>
              <p class="Fuell-Text Fuell-Text--centered">{{modalResourceLabelZeroResults}}</p>
            </div>

            <!-- Contenido del visor -->
            <div :class="receiptContainerClass">

              <!-- Menú Lateral -->
              <div
                :class="receiptListClass"
                v-if="transactionReceipts.length > 1"
              >
                <div
                  class="receipt-list-item"
                  :class="receiptListItemClass"
                  v-for="(receipt, index) in transactionReceipts"
                  :key="receipt.id"
                >
                  <media-resource-viewer
                    :class="{'selected' : receipt.media.id === selectedReceipt}"
                    :showResourceLink="false"
                    :resourceId="receipt.media.id"
                    :imageAlt="`receipt-${index}-${transactionId}`"
                    @emitResourceId="setSelectedReceipt($event)"
                    :resourceData="receipt.media"
                    :pdfClass="isEditingMileageOrDiet ? 'img-content-pdf-horizontal img-thumbnail-pdf-horizontal mx-auto' : 'img-content img-thumbnail'"
                  ></media-resource-viewer>
                  <span class="receipt-number-tag"> Recibo {{index + 1}}</span>
                </div>
              </div>
              <div
                :class="receiptListClass"
                v-if="expenseReceipts.length > 1"
              >
                <div
                  class="receipt-list-item"
                  :class="receiptListItemFooter"
                  v-for="(receipt, index) in expenseReceipts"
                  :key="receipt.id"
                >
                  <media-resource-viewer
                    :class="{'selected' : selectedReceipt === receipt.id}"
                    :file="receipt.file"
                    :imageAlt="`receipt-${index}`"
                    :resourceData="{mimeType: receipt.file.type}"
                    :resourceIndex="index"
                    @emitResourceId="setSelectedReceipt(receipt.id)"
                    :pdfClass="'img-content-pdf-horizontal img-thumbnail-pdf-horizontal mx-auto'"
                  >
                  </media-resource-viewer>
                  <span class="receipt-number-tag"> Recurso {{index + 1}}</span>

                </div>

              </div>
              <!-- Vista Previa -->
              <div
                class="w-100 h-100"
                v-if="hasResources"
              >
                <template v-if="!expenseMode">

                  <transaction-receipt-item
                    :resourceId="selectedReceipt"
                    :hideDelete="transactionLocked"
                    useEmbed
                    :resourceData="{mimeType : 'application/pdf'}"
                    showResourceLink
                    @handleDelete="handleDelete"
                    @resourceDownloaded="trackDownload"
                  ></transaction-receipt-item>
                </template>
                <template v-else>
                  <transaction-receipt-item
                    v-if="expenseReceipts.length >= 1"
                    :file.sync="selectedFile"
                    useEmbed
                    :resourceData="{mimeType :selectedFile.type}"
                    :hideDelete="transactionLocked"
                    showResourceLink
                    showControls
                    @handleDelete="handleDelete(selectedReceipt)"
                    @resourceDownloaded="trackDownload"
                    isExpense
                  ></transaction-receipt-item>
                </template>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <confirm-modal
      v-if="showConfirmModal"
      :open.sync="showConfirmModal"
      :title="'ACTION_REMOVE'"
      :acceptText="'ACTION_REMOVE'"
      @accept="deleteReceipt"
      @dismiss="dismissDelete"
    ></confirm-modal>
  </div>
</template>

<script>
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import MediaResourceViewer from '@/components/Commons/MediaResourceViewer'
import TransactionReceiptItem from './TransactionReceiptItem'

import { segmentTrack } from '@/analytics/segment'
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')

export default {
  name: 'TransactionReceiptsViewerModal',
  mixins: [_modalHandlerMixin],
  props: {
    transactionId: {
      type: [Number, String]
    },
    preloadReceiptId: {
      type: [Number, String]
    },
    expenseMode: {
      type: Boolean
    },
    expenseType: {
      type: String
    }
  },
  data () {
    return {
      receipts: [],
      showConfirmModal: false,
      deletingReceipt: false,
      receiptToDelete: null,
      selectedReceipt: 0,
      selectedFile: 0
    }
  },
  components: {
    MediaResourceViewer,
    ConfirmModal,
    TransactionReceiptItem
  },
  computed: {
    transaction () {
      return this.$store.getters['TransactionsStore/currentTransaction'] || {}
    },
    transactionReceipts () {
      return this.transaction && this.transaction.receipt ? this.transaction.receipt.receiptMedia : []
    },
    transactionLocked () {
      return this.transaction && this.transaction.lockedAt
    },
    expenseReceipts () {
      return this.$store.getters['TransactionsStore/currentExpenseReceipts'] || []
    },
    hasResources () {
      return this.expenseReceipts.length > 0 || this.transactionReceipts.length > 0
    },
    modalHeader () {
      return this.expenseMode ? this.$t('expenses_receipts_modal_header') : this.$t('transactions_receipt_modal_header')
    },
    modalResourcesLabel () {
      return this.expenseMode ? this.$t('expenses_receipt_modal_body') : this.$t('transactions_receipt_modal_body')
    },
    modalResourceLabelZeroResults () {
      return this.expenseMode ? this.$t('expenses_receipt_modal_body_zero_results') : this.$t('transactions_receipt_modal_body_zero_results')
    },
    transactionType () {
      return this.transaction ? this.transaction.type : false
    },
    isExpense () {
      return this.transaction && this.transaction.expense ? this.transaction.expense.type.code === 'NORMAL' : false
    },
    isNormalTransaction () {
      return this.transaction && this.transaction.type && this.transaction.type.code === 'NORMAL'
    },
    allowSimultaneousEdit () {
      return this.isNormalTransaction ||
        this.isExpense ||
        this.expenseType === 'EXPENSE'
    },
    receiptModalIsOpen () {
      return this.$store.getters['TransactionsStore/receiptModalIsOpen']
    },
    isEditingMileageOrDiet () {
      return (this.receiptModalIsOpen === 'MILEAGE' || this.receiptModalIsOpen === 'DIET')
    },
    modalWindowSize () {
      if (this.noModalOpen) {
        return ''
      }
      if (this.isEditingMileageOrDiet && this.$store.getters['GlobalStore/modalIsOpen']) {
        return 'Fuell-Modal--window-wide-side-edit'
      }
      if (this.allowSimultaneousEdit && this.$store.getters['GlobalStore/modalIsOpen']) {
        return 'Fuell-Modal--window--side-edit'
      }
      return ''
    },
    noModalOpen () {
      return this.$store.getters['TransactionsStore/receiptModalIsOpen'] === 'NONE'
    },
    fuellModalAlignmentClass () {
      if (this.noModalOpen) {
        return ''
      }
      return this.isEditingMileageOrDiet ? 'Fuell-Modal--align-left' : ''
    },
    fuellModalContentClass () {
      if (this.noModalOpen) {
        return ''
      }
      return this.isEditingMileageOrDiet ? 'Fuell-Modal--content-side-edit' : ''
    },
    receiptContainerClass () {
      if (this.noModalOpen) {
        return 'receipt-container'
      }
      return this.isEditingMileageOrDiet ? 'receipt--container-side-edit' : 'receipt-container'
    },
    receiptListClass () {
      if (this.noModalOpen) {
        return 'receipt-list-sidebar'
      }
      return this.isEditingMileageOrDiet ? 'receipt-list-footer-bar' : 'receipt-list-sidebar'
    },
    receiptListItemClass () {
      if (this.noModalOpen) {
        return ''
      }
      return this.isEditingMileageOrDiet ? 'receipt-list-item--footer' : ''
    },
    receiptListItemFooter () {
      if (this.noModalOpen) {
        return ''
      }
      return this.isEditingMileageOrDiet ? 'receipt-list-item--footer' : ''
    }
  },
  methods: {
    getResourceId (index) {
      let resource = this.transactionReceipts.find(el => el.id === index)
      if (resource) {
        return resource.id
      } else {
        return this.transactionReceipts[index]
      }
    },
    async deleteReceipt () {
      if (!this.receiptToDelete) return
      if (!this.expenseMode) {
        this.deletingReceipt = true
        await this.$store.dispatch('TransactionsStore/deleteTransactionReceipt', this.receiptToDelete)
        await this.$store.dispatch('TransactionsStore/fetchTransaction', this.transactionId)

        segmentTrack('Transaction ticket removed', {
          transaction_id: this.transaction.id,
          picture_count: this.transactionReceipts ? this.transactionReceipts.length : 0,
          tickets_removed: 1 // tickets are removed one by one
        })

        this.receiptToDelete = null
        this.deletingReceipt = false
      } else {
        this.$store.dispatch('TransactionsStore/deleteExpenseReceipt', this.receiptToDelete)

        if (this.expenseReceipts.length > 0) {
          this.selectedReceipt = this.expenseReceipts[0].id
          this.selectedFile = this.expenseReceipts[0].file
        }
      }
    },
    handleDelete (receipt) {
      if (this.transactionLocked) return
      this.receiptToDelete = receipt
      this.showConfirmModal = true
    },
    dismissDelete () {
      this.receiptToDelete = null
    },
    setSelectedReceipt (receiptId) {
      if (this.expenseMode) {
        let fileToShow = this.expenseReceipts.find(el => el.id === receiptId)

        this.selectedFile = fileToShow ? fileToShow.file : this.expenseReceipts[0].file
        this.selectedReceipt = receiptId
      } else {
        this.selectedReceipt = receiptId
      }
    },
    trackDownload (event) {
      segmentTrack('Transaction ticket receipt downloaded', {
        ticket_id: event
      })
    }
  },
  mounted () {
    if (this.expenseMode) {
      let fileToShow = this.expenseReceipts.find(el => el.id === this.preloadReceiptId)

      this.selectedFile = fileToShow ? fileToShow.file : this.expenseReceipts[0].file
      this.selectedReceipt = this.preloadReceiptId
    } else {
      if (this.preloadReceiptId) {
        this.selectedReceipt = this.preloadReceiptId
      } else {
        this.selectedReceipt = this.transactionReceipts[0].media.id
      }
    }
    if (this.$store.getters['TransactionsStore/receiptModalIsOpen'] !== 'NONE') {
      if (this.transactionId) {
        // Chekcs if is normal expense or transaction
        if (this.isExpense || this.isNormalTransaction) {
          this.$store.dispatch(
            'TransactionsStore/setReceiptModalIsOpen',
            this.transactionType.code
          )
        } else {
          this.$store.dispatch(
            'TransactionsStore/setReceiptModalIsOpen',
            this.transaction.expense.type.code
          )
        }
      } else {
        this.$store.dispatch(
          'TransactionsStore/setReceiptModalIsOpen',
          this.expenseType
        )
      }
    }
  },
  destroyed () {
    this.$store.dispatch('TransactionsStore/setReceiptModalIsOpen', false)
  },
  watch: {
    'transactionReceipts.length': function (newV, oldV) {
      if (newV) {
        this.selectedReceipt = this.transactionReceipts[0].media.id
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/styles/transactions/transactions-receipt-viewer.scss";
</style>

<style scoped>
.Fuell-Overlay--lower-z-index {
  z-index: 11 !important;
}
.Fuell-Overlay {
  z-index: 2001;
}
.Fuell-Modal--window {
  height: 90vh;
  width: 80vw;
}

.Fuell-Modal--content {
  padding: 10px;
}

.receipt-list-sidebar {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  margin-right: 2em;
  overflow-y: auto;
  height: 100%;
  max-height: 528px;
  flex: 1 1 25%;
}
.receipt-number-tag {
  display: flex;
  font-size: 12px;
  justify-content: center;
  margin: 10px 0px;
}
.receipt-list-item >>> .img-content:hover {
  border: 1px solid var(--gray-light);
  transition: border 1s ease-out;
}
.receipt-list-item .selected >>> .img-content {
  border: 1px solid var(--text-heading);
}
.receipt-list-item .selected >>> .img-content-pdf-horizontal {
  border: 1px solid var(--text-heading);
}

@media screen and (max-width: 768px) {
  .Fuell-Modal--window {
    height: 100vh;
    width: 100vw;
    margin: 0px;
    padding: 0px;
  }
  .Fuell-Modal--content {
    padding: 0px;
  }
  .receipt-container {
    flex-direction: column !important;
  }
  .receipt-list-sidebar {
    flex-direction: row;
    justify-content: space-between;
    padding: 10px;
    margin: 0px;
    overflow-y: hidden;
    overflow-x: auto;
    height: 100%;
    max-height: 200px;
    flex: 1 1 35%;
  }
  .receipt-list-item {
    height: 175px;
    margin: 0px 10px;
  }
}
</style>
